import React, { useState } from 'react';
import { Button, Container } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import SquareLogo from '../img/square.png';

function CreateNewBook() {
    const { id } = useParams();
    const [title, setTitle] = useState('');
    const [image, setImage] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!title || !description) {
            setError("Musíš vyplnit všechna pole");
            return;
        }

        setError('');

        try {
            const response = await fetch('https://api.lexikonn.eu/mau/createbook.php?u='+localStorage.getItem("mau_user"), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ title, description, id, image }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Chyba při vytváření příběhu.');
            }
            window.location.href = "/";
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <Container className="me-auto mt-5">
            <h2>Založ nový příběh</h2>
            {error && <div className="text-danger mb-3">{error}</div>}
            <form onSubmit={handleSubmit}>
                <div className="mb-3"></div>
                <input
                    className="form-control mb-3"
                    placeholder="Titulek"
                    name="title"
                    required
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <textarea
                    className="form-control mb-3"
                    placeholder="Krátký popis příběhu"
                    name="description"
                    required
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
                <input
                    className="form-control mb-3"
                    placeholder="URL obálky"
                    name="image"
                    required
                    value={image}
                    onChange={(e) => setImage(e.target.value)}
                />
                <Button variant="success" type="submit">Založit</Button>
            </form>
            <div className="text-center">
                <img className="img-fluid" src={SquareLogo} alt="World by Mau"/>
            </div>
        </Container>
    );
}

export default CreateNewBook;
